var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Fill_1","data-name":"Fill 1","d":"M12,24A12,12,0,0,1,3.515,3.515a12,12,0,1,1,16.97,16.97A11.922,11.922,0,0,1,12,24Zm2.034-12.213c.482,0,.968.418.968,1.352V16h2V12.641a2.967,2.967,0,0,0-.648-2.034A1.91,1.91,0,0,0,14.92,9.99,2.219,2.219,0,0,0,13,11.093V10H11v6h2V13.139C13,12.252,13.52,11.787,14.034,11.787ZM8,10v6h2V10ZM9,6.891A1.109,1.109,0,1,0,10.1,8,1.106,1.106,0,0,0,9,6.891Z","transform":"translate(0 0)"}));
}

Linkedin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
